import { filterTypes } from './enums';

const debounce = function debounce(func, wait, immediate) {
  let timeout;
  return function debouncedFunc(...args) {
    const context = this;
    const later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

const composedPath = (evt) => {
  let path = (evt.composedPath && evt.composedPath()) || evt.path;
  const { target } = evt;

  if (path != null) {
    // Safari doesn't include Window, and it should.
    path = !path.includes(window) ? path.concat([window]) : path;
    return path;
  }

  if (target === window) {
    return [window];
  }

  function getParents(node, memo) {
    // eslint-disable-next-line no-param-reassign
    memo = memo || [];
    const { parentNode } = node;

    if (!parentNode) {
      return memo;
    }
    return getParents(parentNode, memo.concat([parentNode]));
  }

  return [target].concat(getParents(target)).concat([window]);
};

const pathIncludesClass = (event, className) => composedPath(event)
  .filter((el) => el !== document && el !== window)
  .reduce((acc, e) => acc.concat([...e.classList]), [])
  .includes(className);

const checkClassWhitelistOnClick = (e, classWhitelist) => {
  const classArray = Array.isArray(classWhitelist)
    ? classWhitelist
    : [classWhitelist];

  return (
    e
    && classArray.filter((className) => pathIncludesClass(e, className)).length > 0
  );
};

// filter utils
const parseQueryParams = (value, type) => {
  // Strings
  if (typeof (value) === 'string' && type === filterTypes.BOOLEAN) {
    // Convert string boolean to boolean
    if (value.toLowerCase() === 'true') return true;
    if (value.toLowerCase() === 'false') return false;
  }

  if (type === filterTypes.NUMBER) {
    // Convert string int to int
    if (!Number.isNaN(value)) return parseInt(value, 10);
  }

  // Arrays
  if (type === filterTypes.INT_ARRAY && value !== undefined) {
    if (Array.isArray(value)) {
      // Convert string int to int
      return value.map((e) => (!Number.isNaN(e) ? parseInt(e, 10) : e));
    }
    return [parseInt(value, 10)];
  }

  return value;
};

const getFiltersFromUrlQuery = ({ filters, $route }) => {
  const result = {};
  filters.forEach((filter) => {
    const value = $route.query?.filter?.[filter.key];
    if (value) {
      result[filter.key] = parseQueryParams(value, filter.type);
    }
  });
  return result;
};

const setUrlFiltersIntoState = ({
  filters, $route, $set, filtersData,
}) => {
  const parsedFilters = getFiltersFromUrlQuery({ filters, $route });
  Object.entries(parsedFilters).forEach(([key, value]) => {
    $set(filtersData, key, value);
  });
};

export {
  // eslint-disable-next-line
  debounce,
  checkClassWhitelistOnClick,
  parseQueryParams,
  getFiltersFromUrlQuery,
  setUrlFiltersIntoState,
};
